import styles1 from "../styles/tables";
import styles2 from "../styles/modales";
import React, { useState, useRef, useEffect } from "react";
import Navbar from "../components/navbar";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { getMe } from "../api/users";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import {toast} from "../components/toast";
import Loader from "../components/Loader";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  getRoadbookPages,
  createRoadbookPage,
  updateRoadbookPage,
  deleteRoadbookPage,
} from "../api/roadbook";

const styles = { ...styles1, ...styles2 };

function Roadbook() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: me } = useQuery("me", () => getMe(navigate));
  const { data: pages, isLoading } = useQuery("roadbook_pages", getRoadbookPages);

  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ title: "", slug: "", content: "", position: 0, parent_id: null, active: true });
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showForm]);

  const createMutation = useMutation(createRoadbookPage, {
    onSuccess: () => { queryClient.invalidateQueries("roadbook_pages"); resetForm(); },
    onError: (error) => { toast.error("Erreur lors de la création : " + (error.response?.data?.errors?.join(", ") || error.message)); },
  });

  const updateMutation = useMutation(({ id, data }) => updateRoadbookPage(id, data), {
    onSuccess: () => { queryClient.invalidateQueries("roadbook_pages"); resetForm(); },
    onError: (error) => { toast.error("Erreur lors de la modification : " + (error.response?.data?.errors?.join(", ") || error.message)); },
  });

  const deleteMutation = useMutation(deleteRoadbookPage, {
    onSuccess: () => queryClient.invalidateQueries("roadbook_pages"),
    onError: (error) => { toast.error("Erreur lors de la suppression : " + (error.response?.data?.errors?.join(", ") || error.message)); },
  });

  const resetForm = () => {
    setForm({ title: "", slug: "", content: "", position: 0, parent_id: null, active: true });
    setEditing(null);
    setShowForm(false);
  };

  const handleEdit = (page) => {
    setForm({
      title: page.title,
      slug: page.slug,
      content: page.content || "",
      position: page.position || 0,
      parent_id: page.parent_id,
      active: page.active,
    });
    setEditing(page.id);
    setShowForm(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editing) {
      updateMutation.mutate({ id: editing, data: form });
    } else {
      createMutation.mutate(form);
    }
  };

  const handleDelete = (id) => {
    if (window.confirm("Supprimer cette page du roadbook ?")) {
      deleteMutation.mutate(id);
    }
  };

  const renderPage = (page, level = 0) => (
    <div key={page.id} style={{ marginLeft: level * 24, padding: "12px 16px", borderBottom: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div>
        <strong>{page.title}</strong>
        <span style={{ marginLeft: 10, fontSize: 12, color: "#888" }}>/{page.slug}</span>
        {!page.active && <span style={{ marginLeft: 10, fontSize: 11, color: "#C24A4A", fontWeight: 600 }}>Inactif</span>}
      </div>
      <div>
        <button type="button" onClick={() => handleEdit(page)} style={{ marginRight: 8, padding: "4px 12px", border: "1px solid #2C5F2D", borderRadius: 6, backgroundColor: "white", color: "#2C5F2D", cursor: "pointer", fontSize: 13 }}>
          Modifier
        </button>
        <button type="button" onClick={() => handleDelete(page.id)} style={{ padding: "4px 12px", border: "1px solid #C24A4A", borderRadius: 6, backgroundColor: "white", color: "#C24A4A", cursor: "pointer", fontSize: 13 }}>
          Supprimer
        </button>
      </div>
    </div>
  );

  const renderTree = (pages) => {
    if (!pages) return null;
    return pages.map((page) => (
      <React.Fragment key={page.id}>
        {renderPage(page, 0)}
        {page.children && page.children.map((child) => renderPage(child, 1))}
      </React.Fragment>
    ));
  };

  return (
    <div style={styles.page}>
      <Header />
      <Navbar page={"roadbook"} me={me} />
      <div style={styles.SectionInfo}>
        <div style={styles.h1}>
          <span style={styles.h1W}>Roadbook</span>
        </div>
      </div>

      <div style={{ padding: "0px 200px" }}>
        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <h3 style={{ margin: 0 }}>Pages du roadbook</h3>
            <button type="button" onClick={() => { setForm({ title: "", slug: "", content: "", position: 0, parent_id: null, active: true }); setEditing(null); setShowForm(true); }} style={{ padding: "8px 20px", backgroundColor: "#2C5F2D", color: "white", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
              + Nouvelle page
            </button>
          </div>

          {isLoading && <Loader />}
          {pages && pages.length === 0 && <p style={{ color: "#888" }}>Aucune page. Créez la première !</p>}
          {renderTree(pages)}
        </div>

        {showForm && (
          <div ref={formRef} style={{ marginTop: 24, backgroundColor: "white", borderRadius: 12, padding: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "2px solid #2C5F2D" }}>
            <h4>{editing ? "Modifier la page" : "Nouvelle page"}</h4>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 600 }}>Titre</label>
                <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc" }} required />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 600 }}>Slug (URL)</label>
                <input type="text" value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc" }} placeholder="Laissez vide pour générer automatiquement" />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 600 }}>Contenu</label>
                <ReactQuill
                  theme="snow"
                  value={form.content}
                  onChange={(value) => setForm({ ...form, content: value })}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link", "image"],
                      [{ align: [] }],
                      ["clean"],
                    ],
                  }}
                  style={{ backgroundColor: "white", minHeight: 200 }}
                />
              </div>
              <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: "block", marginBottom: 4, fontWeight: 600 }}>Position</label>
                  <input type="number" value={form.position} onChange={(e) => setForm({ ...form, position: parseInt(e.target.value) || 0 })} style={{ padding: 8, borderRadius: 6, border: "1px solid #ccc", width: 80 }} />
                </div>
                <div>
                  <label style={{ display: "block", marginBottom: 4, fontWeight: 600 }}>Page parente</label>
                  <select value={form.parent_id || ""} onChange={(e) => setForm({ ...form, parent_id: e.target.value || null })} style={{ padding: 8, borderRadius: 6, border: "1px solid #ccc" }}>
                    <option value="">Aucune (page racine)</option>
                    {pages && pages.map((p) => (
                      <option key={p.id} value={p.id}>{p.title}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <label>
                    <input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} style={{ marginRight: 6 }} />
                    Actif
                  </label>
                </div>
              </div>
              <div style={{ display: "flex", gap: 12 }}>
                <button type="submit" style={{ padding: "8px 20px", backgroundColor: "#2C5F2D", color: "white", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
                  {editing ? "Enregistrer" : "Créer"}
                </button>
                <button type="button" onClick={resetForm} style={{ padding: "8px 20px", backgroundColor: "#f0f0f0", color: "#333", border: "none", borderRadius: 8, cursor: "pointer" }}>
                  Annuler
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default Roadbook;
